import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { DnNotyComponent } from './dn-noty/dn-noty.component';

@NgModule({
  declarations: [DnNotyComponent],
  imports: [CommonModule, MatSnackBarModule, MatIconModule],
  exports: [DnNotyComponent],
})
export class DnNotyModule {}
